import React, { useState, useEffect } from 'react';
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';

// material-ui icons
import { LocalShipping, Save, Visibility } from '@material-ui/icons';

// core components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import Button from 'components/CustomButtons/Button.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js';
import moment from 'moment';
import { wsGetAll, wsUrl, wsFindBy, wsCreate } from 'services/WService';

import ModalFull from 'components/Tvendo/Common/ModalFull.js';
import ProgMap from './components/ProgMap';

const useStyles = makeStyles({
  ...styles,
  float: {
    margin: 'auto',
    float: 'right',
  },
  color: {
    color: 'black',
  },
  hr: {
    width: '95%',
  },
});

export default WithApp(function ProgrammingNew(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const [dataFilter, setDataFiter] = useState({
    start_date: moment().subtract(2, 'days').format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
  });

  const [vehicle, setVehicle] = useState({});
  const [checkedRoutes, setCheckedRoutes] = useState([]);
  const [checkedOrders, setCheckedOrders] = useState([]);

  const [data, setData] = useState({
    base_zone_id: 1,
    scheduled_date: moment().format('YYYY-MM-DD'),
  });

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  // #region Listado de datos desde API
  const [zones, setZones] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [jefeMercas, setJefeMercas] = useState([]);
  const [jefeDists, setJefeDists] = useState([]);
  const [refreshRoutes, setRefreshRoutes] = useState(false);
  const [generating, setGenerating] = useState(false);
  const [dataKey, setDataKey] = useState(0);

  async function listZone() {
    let response = await wsGetAll('base/zone');
    if (response.success) {
      setZones(response.data);
    }
  }

  async function getWarehouses(idZone) {
    let response = await wsFindBy(`base/zone/${idZone}/warehouse`);
    if (response.success) setWarehouses([response.data]);
  }

  async function listVehicles(idZone) {
    let response = await wsFindBy('prog/vehicle', { base_zone_id: idZone });
    if (response.success) {
      setVehicles(response.data);
    }
  }

  async function listManagers(idZone) {
    let response = await wsFindBy('prog/distribution-staff', { base_zone_id: idZone });
    if (response.success) {
      setJefeMercas(response.data.filter((item) => item.base_employee_positon_id == '1'));
      setJefeDists(response.data.filter((item) => item.base_employee_positon_id == '2'));
    }
  }
  //#endregion

  // #region funciones de procesos internos
  /**
   * @param {*recibe el vehiculo seleccionado} vehicle
   * luego setea vehiculo y alavez elige el JReparto y JMerca
   */
  function selectVehicle(vehicle) {
    setVehicle(vehicle);
    setData({
      ...data,
      prog_vehicle_id: vehicle.id,
      prog_distribution_staff_id_manager: vehicle.prog_distribution_staff_id_manager,
      prog_distribution_staff_id_inventory_manager:
        vehicle.prog_distribution_staff_id_inventory_manager,
    });
  }

  /**
   * @param {*recibe una zona seleccionada} zone
   * limpia la data dependiente de zona
   * lista los datos que necesitan el id zona
   * limpia las rutas seleccionadas
   */
  function selectZone(zone) {
    delete data.logi_warehouse_id;
    delete data.prog_vehicle_id;
    delete data.prog_distribution_staff_id_manager;
    delete data.prog_distribution_staff_id_inventory_manager;
    setVehicle({});
    getWarehouses(zone.id);
    listVehicles(zone.id);
    listManagers(zone.id);
    setCheckedRoutes([]);
  }
  //#endregion

  //#region visualizar pdf
  const [urlPDF, setUrlPDF] = useState({ consolidate: '' });
  const [showConsolidate, setShowConsolidate] = useState(false);

  async function getUrlConsolidate(arrayOrders) {
    let orderIds = arrayOrders.map((item) => item.id);
    let valueSearch = {
      sale_order_id: orderIds,
      prog_vehicle_id: data.prog_vehicle_id || '',
      prog_distribution_staff_id_manager: data.prog_distribution_staff_id_manager || '',
      prog_distribution_staff_id_inventory_manager:
        data.prog_distribution_staff_id_inventory_manager || '',
    };
    for (var clave in valueSearch) {
      if (valueSearch[clave] == null || valueSearch[clave] == '') {
        delete valueSearch[clave]; //eliminamos las claves nulas
      }
    }
    let urlPdfConsolidate = await wsUrl('prog/consolidated', valueSearch);
    setUrlPDF({ consolidate: urlPdfConsolidate });
    setShowConsolidate(true);
  }

  function clearData() {
    setVehicle({});
    setCheckedRoutes([]);
    setCheckedOrders([]);
    const {
      prog_vehicle_id,
      prog_distribution_staff_id_inventory_manager,
      prog_distribution_staff_id_manager,
      ...rest
    } = data;
    setData(rest);
    setRefreshRoutes(!refreshRoutes);
  }
  //#endregion

  async function save(data, ordersIds) {
    ordersIds = ordersIds.map((item) => item.id);
    if (ordersIds.length < 1) {
      showNotify('Seleccione pedidos', 'info');
      return;
    }
    setGenerating(true);
    let response = await wsCreate('prog/sheet-distribution', {
      sheet_distribution: data,
      orders: ordersIds,
    });
    setGenerating(false);
    if (response.success) {
      setDataKey((key) => key + 1);
      showNotify(
        `${response.message} HR: ${response.data.sheet_distribution} / ${response.data.details} / ${response.data.shet_load}`,
      );
      clearData();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    listZone();
    getWarehouses(data.base_zone_id);
    listVehicles(data.base_zone_id);
    listManagers(data.base_zone_id);
  }, []);

  return (
    <>
      <Toasty action={notify} />
      <ModalFull
        title="Hoja consolidado"
        open={showConsolidate}
        setOpen={setShowConsolidate}
        iframe
      >
        <iframe
          src={showConsolidate ? urlPDF?.consolidate : undefined}
          width="100%"
          height="100%"
          title="Pdf"
        >
          No se pudo cargar el contenido.
        </iframe>
      </ModalFull>

      <form
        id="consolidate"
        onSubmit={(e) => {
          e.preventDefault();
          save(data, checkedOrders);
        }}
      >
        <GridContainer>
          <GridItem lg={2} sm={2} xl={2} xs={12}>
            <TextField
              label="Fecha Inicial"
              type="date"
              fullWidth
              size="small"
              mindate={moment().subtract(2, 'days').format('YYYY-MM-DD')}
              defaultValue={dataFilter.start_date || ''}
              onChange={(e) =>
                setDataFiter({
                  ...dataFilter,
                  start_date: e.target.value,
                })
              }
            />
          </GridItem>
          <GridItem lg={2} sm={2} xl={2} xs={12}>
            <TextField
              label="Fecha Final"
              type="date"
              fullWidth
              size="small"
              defaultValue={dataFilter.end_date || ''}
              onChange={(e) =>
                setDataFiter({
                  ...dataFilter,
                  end_date: e.target.value,
                })
              }
            />
          </GridItem>
          <GridItem lg={2} sm={2} xl={2} xs={12}>
            <FormControl fullWidth size="small" required>
              <InputLabel>Zonas</InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                value={data.base_zone_id}
                inputProps={{
                  name: 'base_zone_id',
                  onChange: handleChange,
                }}
              >
                {zones.map((zone, i) => {
                  return (
                    <MenuItem key={i} value={zone.id} onClick={() => selectZone(zone)}>
                      {zone.description}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem lg={2} sm={2} xl={2} xs={12}>
            <FormControl fullWidth size="small" required>
              <InputLabel>Almacén</InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                value={data.logi_warehouse_id || ''}
                inputProps={{
                  name: 'logi_warehouse_id',
                  onChange: handleChange,
                }}
              >
                {warehouses.map((warehouse, i) => {
                  return (
                    <MenuItem
                      key={i}
                      value={warehouse.id}
                      onClick={() => {
                        setDataFiter({
                          ...dataFilter,
                          logi_warehouse_id: warehouse.id,
                        });
                      }}
                    >
                      {warehouse.WhsName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem lg={4} sm={4} xl={4} xs={12}>
            <div className={classes.float}>
              <Button
                color="info"
                round
                className={classes.marginRight}
                onClick={() => {
                  if (checkedOrders.length > 0) {
                    getUrlConsolidate(checkedOrders);
                  }
                  checkedOrders.length > 0
                    ? setShowConsolidate(true)
                    : showNotify('No hay ordenes seleccionadas', 'info');
                }}
                disabled={generating}
              >
                <Visibility className={classes.icons} />
                Ver consolidado
              </Button>
              <Button
                type="submit"
                form="consolidate"
                color={props.themeContext.buttonColorSuccess}
                round
                className={classes.marginRight}
                disabled={generating}
              >
                <Save className={classes.icons} />
                Generar
              </Button>
            </div>
          </GridItem>
        </GridContainer>
        <br />
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <LocalShipping />
            </CardIcon>
            <h4 className={classes.color}>Vehículo</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem lg={4} sm={4} xl={4} xs={12}>
                <FormControl fullWidth size="small" required>
                  <InputLabel>Vehículos</InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    inputProps={{
                      name: 'prog_vehicle_id',
                    }}
                    value={data.prog_vehicle_id || ''}
                  >
                    {vehicles.map((vehicle, i) => {
                      return (
                        <MenuItem
                          value={vehicle.id}
                          onClick={() => {
                            selectVehicle(vehicle);
                          }}
                          key={vehicle.id}
                        >
                          {vehicle.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem sm={2} xl={2} xs={12}>
                <TextField
                  label="Cod. Vehículo"
                  fullWidth
                  size="small"
                  value={vehicle.code || ''}
                  disabled
                />
              </GridItem>
              <GridItem sm={2} xl={2} xs={12}>
                <TextField
                  label="Capacidad (Peso)"
                  fullWidth
                  size="small"
                  value={vehicle.weight || ''}
                  disabled
                />
              </GridItem>
              <GridItem sm={2} xl={2} xs={12}>
                <TextField
                  label="Modelo"
                  fullWidth
                  size="small"
                  value={vehicle.model || ''}
                  disabled
                />
              </GridItem>
              <GridItem sm={2} xl={2} xs={12}>
                <TextField
                  label="Color"
                  fullWidth
                  size="small"
                  value={vehicle.color || ''}
                  disabled
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem sm={3} xl={3} xs={12}>
                <FormControl fullWidth margin="normal" size="small" required>
                  <InputLabel>Jefe Reparto</InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    inputProps={{
                      name: 'prog_distribution_staff_id_manager',
                      onChange: handleChange,
                    }}
                    value={data.prog_distribution_staff_id_manager || ''}
                  >
                    {jefeDists.map((item) => {
                      return (
                        <MenuItem value={item.id} key={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem sm={2} xl={2} xs={12}>
                <TextField
                  disabled
                  label="lic. Conducir"
                  fullWidth
                  margin="normal"
                  size="small"
                  value={
                    jefeDists?.filter(
                      (item) => item.id == data.prog_distribution_staff_id_manager,
                    )[0]?.driver_license || ''
                  }
                />
              </GridItem>
              <GridItem sm={3} xl={2} xs={12}>
                <FormControl fullWidth margin="normal" size="small" required>
                  <InputLabel>Encargado de mercadería</InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu,
                    }}
                    inputProps={{
                      name: 'prog_distribution_staff_id_inventory_manager',
                      onChange: handleChange,
                    }}
                    value={data.prog_distribution_staff_id_inventory_manager || ''}
                  >
                    {jefeMercas.map((item, i) => {
                      return (
                        <MenuItem value={item.id} key={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </form>
      <br />
      <ProgMap
        zoneId={data.base_zone_id}
        dataKey={dataKey}
        dataFilter={dataFilter}
        setCheckedOrders={setCheckedOrders}
        generating={generating}
      />
    </>
  );
});
